// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"nt-z","modalContent":"ot-z","header":"pt-z","close":"qt-z"};